import * as React from "react";
import classNames from "classnames";
import { Icon } from "components";
import {
  Checkbox as UICheckbox,
  CheckboxProps as UICheckboxProps,
} from "@stemscopes/ui";
import uniqueId from "lodash-es/uniqueId";
import { formHooks } from "../../../form/duck";
import InputError from "../../input-error";
import styles from "./Checkbox.module.css";

const Checkbox: React.FC<UICheckboxProps> = ({
  className,
  iconContainerClassName = "",
  name,
  checked,
  ...rest
}) => {
  const [field, { error }] = formHooks.useField<boolean>({
    name,
  });
  const errorId = React.useMemo(() => uniqueId("error-"), []);

  const computedChecked =
    typeof field.value === "undefined" ? checked : field.value;

  return (
    <>
      {/* eslint-disable-next-line */}
      {/*
  // @ts-ignore */}
      <UICheckbox
        {...field}
        {...rest}
        name={name}
        checked={computedChecked}
        className={classNames(styles.wrapper, className)}
        iconContainerClassName={classNames(
          styles.iconContainer,
          iconContainerClassName,
          {
            [styles.checked]: computedChecked,
          },
        )}
        icon={(isChecked) =>
          isChecked ? (
            <Icon name="check-outlined" className={styles.icon} />
          ) : undefined
        }
        aria-errormessage={errorId}
        aria-invalid={!!error}
      />
      <InputError error={error} errorId={errorId} />
    </>
  );
};

export default Checkbox;
